<template>
  <div id="my_video">

    <ul id="video_left">
      <li>
        <span @click="open" v-if="isPlay">
          <Button type="success" shape="circle" icon="md-play"></Button>播放
        </span>
        <span @click="pause" v-if="!isPlay">
          <Button type="success" shape="circle" icon="md-pause"></Button>暂停
        </span>
      </li>
      <li>
        <span @click="toSpeakPage" v-if="isSpeaker">
          <Button type="success" shape="circle" icon="md-mic"></Button>对讲
        </span>
        <span @click="closeSpeak" v-if="!isSpeaker">
          <Button type="success" shape="circle" icon="md-mic-off"></Button>挂断
        </span>
      </li>
      <li @click="close">
        <Button type="error" shape="circle" icon="ios-cut"></Button>断开
      </li>
      <li @click="dasf">
        <Button type="warning" shape="circle" icon="ios-settings"></Button>设置
      </li>
    </ul>
    <div id="videoContainer"></div>
  </div>
</template>
<script>

let playList = [];
let player = null;
let tidObj = null;
export default {
  data() {
    return {
      videoModal: false,
      isPlay: true,
      isSpeaker: true,
      deviceNo: "",
      carNo: "",
    };
  },
  methods: {
    beforCcreatePlayer(v) {
    console.log(v);
      this.deviceProtocol = v.deviceProtocol;
      this.deviceModel = v.deviceModel;
      this.deviceNo = v.deviceNo;
      if (this.deviceProtocol.indexOf("粤标") != -1 || this.deviceProtocol.indexOf("809") != -1) {
        this.deviceNo = "000000000" + v.deviceNo;
      }

      this.carNo = v.carNo;
      this.videoModal = true;
      if (player != null) {
        player.destroy();
        player = null;
        playList = [];
        tidObj = null;
        this.videoModal = false;
        setTimeout(() => {
          this.videoModal = true;
          this.isPlay = true;
          setTimeout(() => {
            this.createPlayer();
          }, 100);
        }, 100);
      } else {
        setTimeout(() => {
          this.createPlayer();
        }, 100);
      }
    },
    createPlayer() {
      var that = this;
      player = new byskplayer({
        id: "videoContainer", //容器
        baseURL: "wss://videostream.car900.com/", //路径
        //baseURL: 'wss://videostream.car900.com/07B7ED0A57724C7705F2C27E13ED57DA',
        // userkey: "c4d1fbb6-2dc5-4f86-a5da-893f80e9d80a", //客户代码
        userkey: "2161e23a-4d3b-4d1a-bf0a-cafd56f9c6f8", //客户代码
        //userkey: '9c6386c7-4987-4a30-ac90-43ad22900a9f',
        isReal: true, //是否实时
        isRecord: false, //是否回放
        userId: "apidemo", //用户id,
        click: this.onPlayClick,
        playstart: this.onPlayStart,
        playend: this.onPlayEnd,
        isSwitchCodetypeOnFullscreen: false, //全屏是否切换高清，默认false
        snapshot: this.onSnapshot,
        message: this.onMessage,
      });

      //player.poster = that.lycsr.vbg; //设置预览图片
      this.mySetPlayerNum(4); //设置视频画面
    },
    mySetPlayerNum(t) {
      player.setPlayerNum(t);
    },
    onPlayClick(e) {
      // console.log(e);
    },
    onSnapshot(e) {
      // console.log(e);
    },
    onMessage(e) {
      if (!(e instanceof String)) {
        let { status, info } = e;
        switch (status) {
          case 19: //视频回放高级别用户通知, //需要主动关闭视频
            record.close();
            alert(info);
            break;
          case 20: //实时对讲高级别用户通知，//需要主动关闭对讲
            real.closeSpeak();
            alert(info);
            break;
        }
      }
    },
    open() {
      let SpecialSign = 0; //0不处理 1--粤标
      let device = this.deviceNo;
      let playerType = 0;
      if (
        this.deviceModel.indexOf("GH11") != -1
      ) {

        playerType = 1;

      }
      if (this.deviceProtocol.indexOf("粤标") != -1 || this.deviceProtocol.indexOf("809") != -1) {
        SpecialSign = 1; //0不处理 1--粤标
      }
      /* if (deviceModel.indexOf('粤标')!=-1) {
        SpecialSign=1;
        device='000000000'+device
      } */
      let channel = 2;
      let protocolType = 1;
      let obj = playList.find(
        (p) => p.device == device && p.channel == channel
      );
      if (obj) return; //已经在播放的则不能再播放

      //const channelArr = channel.split(",").map(p => p * 1);
      const channelArr = [1, 2, 3, 4];
      const tidObj = player.allocate(channelArr.length); //根据通道数申请
      // let tidObj = player.allocate(1); //申请一个视频播放器

      if (tidObj.flag == 1) {
        //申请成功
        let params = {
          SpecialSign: SpecialSign,
          device: device, //终端号
          channel: channel, //通道号 （1~8）
          protocolType: protocolType, //协议类型，1：GF-1078，GB-1078; 2：GA系列
          codeTypeCtrlBtnEnabled: protocolType === 1, //是否显示高标清切换按钮(GF才有高清)
          playerType: playerType//播放器类型 0: video(默认), 1: webgl
        };

        if (protocolType === 1) {
          //1078
          for (let i = 0; i < channelArr.length; i++) {
            const tid = tidObj.ids[i];
            const param = {
              ...params,
              channel: channelArr[i],
            };
            player.real.open(tid, param, (res) => {
              //console.log(res);
              this.isPlay = false;
            });
            playList.push({
              ...param,
            });
          }
        } else if (protocolType === 2) {
          //GA
          player.real.open(tidObj.ids, params, (res) => {
            // console.log(res);
            this.isPlay = false;
          });
          playList.push(
            ...tidObj.ids.map((p, i) => {
              return {
                ...params,
                channel: channelArr[i],
              };
            })
          );
        }
      } else {
        //申请失败
        alert(tidObj.msg);
      }
    },
    pause() {
      let device = this.deviceNo;
      let channel = 2;
      //const channelArr = channel.split(",").map(p => p * 1);
      //const channelArr = [channel];
      const channelArr = [1, 2, 3, 4];
      for (let i = 0; i < channelArr.length; i++) {
        let index = playList.findIndex(
          (p) => p.device == device && p.channel == channelArr[i]
        );
        let obj = playList[index];
        if (obj)
          player.real.close(
            obj.tid,
            {
              device: obj.device,
              channel: obj.channel,
              protocolType: obj.protocolType,
            },
            (res) => {
              this.isPlay = true;
            }
          );
        playList.splice(index, 1);
      }
    },
    onPlayStart(e) {
      this.isPlay = false;
      let index = playList.findIndex(
        (p) => p.device == e.device && p.channel == e.channel
      );
      let obj = playList[index];
      if (obj) return;
      playList.push({
        ...e,
      });
    },
    onPlayEnd(e) {
      let index = playList.findIndex(
        (p) => p.device == e.device && p.channel == e.channel
      );
      playList.splice(index, 1);
    },
    //断开连接
    close() {
      player.destroy();
      player = null;
      playList = [];
      tidObj = null;
      this.isPlay = true;
      this.$emit("closeVideo");
      this.videoModal = false;
    },
    dasf() {
      this.$Message.info("即将开放，敬请期待");
    },
    openSpeak() {
      //暂时先用toSpeakPage跳转方式实现，本函数等到有https后在调用
      let device = this.deviceNo;
      let protocolType = 1;
      const params = {
        device: device, //终端号
        protocolType: protocolType, //协议类型，1：GF-1078，2：GA系列，目前支持GF-1078
      };
      player.real.openSpeak(params, (res) => {
        this.$Message.info(res.info);
        this.isSpeaker = false;
      });
    },
    closeSpeak() {
      let device = this.deviceNo;
      let protocolType = 1;
      const params = {
        device: device,
        protocolType: protocolType,
      };
      player.real.closeSpeak(params, (res) => {
        this.$Message.info(res.info);
        this.isSpeaker = true;
      });
    },
    toSpeakPage(v) {
      // https://test.ly-gps.com/intercom/speak/?deviceNo=13305562161&carNo=粤A1234
      //https://pc.ly-gps.com/intercom/speak/?deviceNo=13305562161&carNo=粤A1234;
      var href =
        "https://pc.ly-gps.com/intercom/speak/?deviceNo=" +
        this.deviceNo +
        "&carNo=" +
        this.carNo;
      console.log(href);
      window.open(href);
    },
  },
  created() {
    // this.createPlayer();
  },
  mounted() {

  },

};
</script>
<style lang="">
#my_video {
  width: 200px;
  min-height: 400px;
  background: #fff;
  padding-bottom: 0px;
  position: relative;
}
#videoContainer {
  width: 100%;
  height:100%;
  background: #ccc;
  margin: 0px 0 0 0;
}
#videoUl {
  display: flex;
  height: 30px;
}
#videoUl li {
  margin-right: 20px;
}
#videoUl li:hover,
#videoUl li:hover i {
  cursor: pointer;
  color: red;
}
#videoUl li i {
  color: #559dfa;
  font-size: 16px;
}

#video_wrap456 .bysk-p-layout-view .layout-4 .num {
  position: relative !important;
  left: 0 !important;
  margin-bottom: 2px;
  outline: solid 8px #fff;
  width: 100%;
  height: 120px;
}
#video_left {
  background: #fff;
  width: 60px;
  height: 290px;
  padding: 14px 15px;
  position: absolute;
  left: -60px;
  top: 50%;
  margin-top: -145px;
  text-align: center;
}
#video_left li {
  margin-bottom: 16px;
}
#video_left li button {
  margin-bottom: 4px;
}
#video_left::before {
  width: 0;
  height: 0;
  content: "";
  position: absolute;
  top: -30px;
  left: 0px;
  border-right: 60px solid #fff;
  border-top: 30px solid transparent;
}
#video_left::after {
  width: 0;
  height: 0;
  content: "";
  position: absolute;
  top: 290px;
  left: 0px;
  border-right: 60px solid #fff;
  border-bottom: 30px solid transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/com/byVideo.vue